import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Calendar, MessageCircle, User, Plus } from 'lucide-react';
import { cn } from '../lib/utils';

const navItems = [
  { path: '/feed', icon: Home, label: 'Discover' },
  { path: '/my-events', icon: Calendar, label: 'Events' },
  { path: '/create-event', icon: Plus, label: 'Create', isSpecial: true },
  { path: '/chats', icon: MessageCircle, label: 'Chats' },
  { path: '/profile', icon: User, label: 'Profile' },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-[100] bg-white border-t border-gray-200 safe-area-pb">
      <div className="flex items-center justify-around py-2 px-4 max-w-lg mx-auto">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          const Icon = item.icon;

          if (item.isSpecial) {
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                data-testid="nav-create"
                className="relative -mt-6"
              >
                <div className="w-14 h-14 rounded-full bg-pink-500 flex items-center justify-center shadow-lg">
                  <Icon className="w-6 h-6 text-white" />
                </div>
              </button>
            );
          }

          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className={cn(
                'flex flex-col items-center gap-1 py-2 px-3 rounded-lg transition-all touch-target',
                isActive ? 'text-pink-500' : 'text-gray-400 hover:text-gray-600'
              )}
            >
              <Icon className={cn('w-6 h-6', isActive && 'stroke-[2.5px]')} />
              <span className={cn('text-xs', isActive ? 'font-semibold' : 'font-medium')}>{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
